import Vue from "vue";
import moment from "moment";
import tripsSynthetic from "./synthetic/trips-synthetic.vue";
import tripsDetail from "./detail/trips-detail.vue";
import { bus } from "../../../../main";
import helpers from "../../../../shared/fleetbox-helpers";

export default {
	components: {
		tripsSynthetic,
		tripsDetail
	},
	data: function() {
		return {
			//#region filters
			filters: [
				{
					id: "timerange",
					items: [],
					value: {
						period: 0,
						startRange: moment(),
						endRange: moment()
					}
				},
				{
					id: "divisions",
					items: [],
					value: ""
				},
				{
					id: "groups",
					items: [],
					value: ""
				},
				{
					id: "vehicles",
					items: [],
					value: []
				},
				{
					id: "drivers",
					items: [],
					value: ""
				}
			],
			//#endregion filters

			isSyntheticLoading: false,
			isDetailLoading: false,

			reportName: ""
		};
	},

	created() {
		var self = this;
		//#region filters
		this.filters[0].value.startRange = moment()
			.add(-7, "days")
			.startOf("day");
		this.filters[0].value.endRange = moment().endOf("day");
		//#endregion filters

		bus.$emit("show-spinner-loading");

		helpers.getReportName().then(res => {
			if (res) {
				var report = res.find(item => {
					return item.id == 210;
				});

				if (report) {
					self.reportName = report.name;
				}
				else {
					self.reportName = "TRAGITTI";
				}
			}
		});
	},
	mounted() {

	},

	watch: {
		isSyntheticLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		},
		isDetailLoading: {
			handler: function() {
				this.loadingProgressUpdate();
			}
		}
	},

	methods: {
		//#region loading progress
		loadingProgressUpdate() {
			if (this.isSyntheticLoading || this.isDetailLoading) {
				bus.$emit("show-spinner-loading");
			}
			else {
				bus.$emit("hide-spinner-loading");
			}
		},
		onDetailLoading(isLoading) {
			this.isDetailLoading = isLoading;
		},
		onSyntheticLoading(isLoading) {
			this.isSyntheticLoading = isLoading;
		},
		//#endregion
		//#region filters events
		onFilterApplyClick() {
			if (this.$refs.tripSyntheticReport) {
				this.$refs.tripSyntheticReport.applyReportFilter();
			}

			if (this.$refs.tripDetailReport) {
				this.$refs.tripDetailReport.applyReportFilter();
			}
		},
		onFilterResetClick() {
			this.setDefaultFilters();
			this.onFilterApplyClick();
		},
		onFilterTimerangeChange(newValue) {
			var timeRangeFilter = this.filters.find(item => {
				return item.id == "timerange";
			});
			if (timeRangeFilter) {
				timeRangeFilter.value.startRange = moment(newValue.startDate);
				timeRangeFilter.value.endRange = moment(newValue.endDate);
			}
		},
		onFilterDivisionChange(newValue) {
			var divisionFilter = this.filters.find(item => {
				return item.id == "divisions";
			});
			if (divisionFilter) {
				Vue.set(divisionFilter, "value", newValue);
			}
		},
		onFilterGroupChange(newValue) {
			var groupFilter = this.filters.find(item => {
				return item.id == "groups";
			});
			if (groupFilter) {
				Vue.set(groupFilter, "value", newValue);
			}
		},
		onFilterDriverChange(newValue) {
			var driverFilter = this.filters.find(item => {
				return item.id == "drivers";
			});
			if (driverFilter) {
				Vue.set(driverFilter, "value", newValue);
			}
		},
		onFilterPlateChange(newValue) {
			var vehiclesFilter = this.filters.find(item => {
				return item.id == "vehicles";
			});
			if (vehiclesFilter) {
				Vue.set(vehiclesFilter, "value", newValue);
			}
		},
		setDefaultFilters() {
			this.filters[0].value.period = "0";
			this.filters[0].value.startRange = moment()
				.add(-7, "days")
				.startOf("day");
			this.filters[0].value.endRange = moment().endOf("day");

			for (var i = 1; i < this.filters.length; i++) {
				var flt = this.filters[i];

				Vue.set(flt, "value", []);
			}
		}
		//#endregion filters events
	},
	computed: {}
};
